export default "__VITE_ASSET__q2O6JkXQ__"